const __WEBPACK_NAMESPACE_OBJECT__ = require("@oraichain/share-serialization");